define([
	"dojo/_base/declare",
	"csi",
	"csi/action/Controller",
	"csi/comm",
	"csi/def",
	"csi/reflectionHints",
	"csi/xml"
], function(declare,csi,Controller,comm,def,reflectionHints,xml) {

	return declare(Controller, {
		constructor: function(/*Object*/params) {
			// summary: the node on which we are acting is the parent
			this.m_urlParent = this.m_urlNode;
			this.m_urlNode = this.m_action._getAggregateUrl(this.getParent(), this.widget.getContext(this.m_urlParent));
		},

		getActionView: function(/*ViewRef?*/vr) {
			// summary: if unlinking, then allow form view; if relinking, allow table view to select new linked node
			var	av = this.inherited(arguments);

			// if no form to be shown
			if (this.m_action.idForm == "") {
				return null;
			}

			if (av) {
				var	bForm = (av.m_defView.getType() == "Form");
				if (bForm && !this.m_bToggle) {
					// if unlink action is bringing up default form, make sure it is not for special path to node type
					var	path = xml.pathCreate(xml.PATH_OP_CHILD, this.m_action.idAttr);

					if ((av.m_defView.m_id != def.DEFAULT_FORM_ID) || !reflectionHints.isSpecialPath(this.getNode().$Type, path)) {
						return av;
					}
				}
			}

			return null;
		},

		getFormData: function() {
			// summary: require one selection
			var	data = this.inherited(arguments);

			if (this.m_bToggle) {
				data.m_bSelectOne = true;
				data.m_bRequireOne = true;
			} else {
				data.m_node = null;
			}

			return data;
		},

		toWriter: function() {
			// summary: unlink or relink based on current state of node

			// extract selection from popup view if present before continuing
			if (this.m_formData && this.m_bToggle) {
				var	node = this.m_formData.getSelectedNode();
				if (node) {
					this.m_cache.cacheNode(node);
					this.m_urlNode = xml.nodeGetURL(node);
				}
			}

			var	call = this.inherited(arguments);
			if (!call) {
				if (this.m_bToggle) {
					// set actual back to original (or new original)
					var	urlCopy = xml.nodeGetAttributeValue(this.getParent(), this.m_action.compositeId);
					var	cnParent = this.m_writer.changeNode(this.m_urlParent);

					// clear composite reference before setting actual so Java can always rely on actual being set last
					if (xml.isValidURL(urlCopy)) {
						cnParent.changeAttribute(this.m_action.compositeId, xml.ATTR_REF, csi.EMPTY_URL);
					}

					// if new node selected, then need to update original as well
					if (this.m_formData) {
						cnParent.changeAttribute(this.m_action.aggregateId, xml.ATTR_REF, this.m_urlNode);
					}

					// set actual reference
					cnParent.changeAttribute(this.m_action.idAttr, xml.ATTR_REF, this.m_urlNode);

					// delete copied node - this must be last so that delete is not stopped by CheckUsageOnDelete constraint on Actual
					if (xml.isValidURL(urlCopy)) {
						this.m_writer.deleteNode(urlCopy);
					}
				} else {
					// make copy of original
					var	urlFrom = this.m_urlNode;

					this.m_urlNode = comm.createUrl();
					if (!this.m_urlNode) throw new Error("URLCREATE");

					this.m_writer.copyNode(this.m_urlNode, urlFrom);

					this.m_writer.changeNode(this.m_urlParent)
						.changeAttribute(this.m_action.compositeId, xml.ATTR_REF, this.m_urlNode)
						.changeAttribute(this.m_action.idAttr, xml.ATTR_REF, this.m_urlNode);
				}
			}

			// write fields to copied node - make sure to use url path from parent in case Requet used to make copy
			if (!this.m_bToggle) {
				this.toWriterFields(xml.getUrlPath(this.m_urlParent, this.m_action.compositeId));
			}

			return call;
		},

		postProcessSuccess: function() {
			// summary: refresh view when done if not already handled
			return this.inherited(arguments) || this.widget.redrawNode(this.m_element);
		}
	});
});